import type { IconData } from '@stacksjs/iconify-core'

export const chevronDown: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default chevronDown
